import { render, staticRenderFns } from "./TaskProps.vue?vue&type=template&id=e1644590&scoped=true"
import script from "./TaskProps.vue?vue&type=script&lang=js"
export * from "./TaskProps.vue?vue&type=script&lang=js"
import style0 from "./TaskProps.vue?vue&type=style&index=0&id=e1644590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1644590",
  null
  
)

export default component.exports